export enum Integration {
  BugZilla = "BugZilla",
  Jira = "Jira",
  Slack = "Slack",
  MS_Teams_Connector = "MS_Teams_Connector",
  Freshrelease = "Freshrelease",
  Azure="Azure",
  Mantis = "Mantis",
  Zepel = "Zepel",
  BackLog = 'BackLog',
  Youtrack="Youtrack",
  GoogleChat = 'GoogleChat',
  Trello = 'Trello',
  Linear = 'Linear',
  TestsigmaLab = "TestsigmaLab",
  ClickUp = 'ClickUp',
  PrivateGrid = 'PrivateGrid',
  XrayCloud = "XrayCloud",
  TestProjectImport = "TestProjectImport",
}
